import { Briefcase, Target, TrendingUp, Users } from "lucide-react";

// Colors reference theme-aware tokens (--tone-* in themes/styles/*.js) so the stat
// icons stay legible in both light and dark themes. Update the tokens to restyle globally.
export const STAT_META = [
  {
    icon: Users,
    color: "rgb(var(--tone-violet))",
    bg: "rgb(var(--tone-violet) / 0.12)",
    border: "rgb(var(--tone-violet) / 0.22)",
  },
  {
    icon: Briefcase,
    color: "rgb(var(--tone-emerald))",
    bg: "rgb(var(--tone-emerald) / 0.12)",
    border: "rgb(var(--tone-emerald) / 0.22)",
  },
  {
    icon: TrendingUp,
    color: "rgb(var(--tone-amber))",
    bg: "rgb(var(--tone-amber) / 0.12)",
    border: "rgb(var(--tone-amber) / 0.22)",
  },
  {
    icon: Target,
    color: "rgb(var(--tone-blue))",
    bg: "rgb(var(--tone-blue) / 0.12)",
    border: "rgb(var(--tone-blue) / 0.22)",
  },
];

// Soft accents per pipeline stage (Applied, Shortlisted, Interviewed, Hired, Rejected).
// Driven by --tone-* tokens, so both themes get the right contrast automatically.
export const PIPELINE_ACCENTS = [
  // { bgClass: "bg-[#FFF9E0]", borderClass: "border-tone-amber/30", textClass: "text-tone-amber" }, // Applied
  { bgClass: "bg-tone-amber-soft", borderClass: "border-tone-amber/30", textClass: "text-tone-amber" }, // Applied
  { bgClass: "bg-tone-blue-soft", borderClass: "border-tone-blue/30", textClass: "text-tone-blue" }, // Shortlisted
  { bgClass: "bg-tone-violet-soft", borderClass: "border-tone-violet/30", textClass: "text-tone-violet" }, // Interviewed
  { bgClass: "bg-tone-orange-soft", borderClass: "border-tone-orange/30", textClass: "text-tone-orange" }, // offered
  { bgClass: "bg-tone-slate-soft", borderClass: "border-tone-slate/30", textClass: "text-tone-slate" }, // On Hold
  { bgClass: "bg-tone-emerald-soft", borderClass: "border-tone-emerald/30", textClass: "text-tone-emerald" }, // Hired
  { bgClass: "bg-tone-rose-soft", borderClass: "border-tone-rose/30", textClass: "text-tone-rose" }, // Rejected
];


export const STAT_ACCENTS = [
  {
    bgClass: "bg-tone-violet-soft",
    borderClass: "border-tone-violet/30",
    textClass: "text-tone-violet",
  },
  {
    bgClass: "bg-tone-emerald-soft",
    borderClass: "border-tone-emerald/30",
    textClass: "text-tone-emerald",
  },
  {
    bgClass: "bg-tone-amber-soft",
    borderClass: "border-tone-amber/30",
    textClass: "text-tone-amber",
  },
  {
    bgClass: "bg-tone-blue-soft",
    borderClass: "border-tone-blue/30",
    textClass: "text-tone-blue",
  },
];